// extracted by mini-css-extract-plugin
module.exports = {"button":"PrimaryActionButton_button__0KoYS"};